<template>
    <div>
        <div v-if="sortedReferrals.length > 0" class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                    <tr>
                        <th 
                            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none whitespace-nowrap"
                            @click="sortBy('referrer_name')"
                        >
                            <div class="flex items-center space-x-1">
                                <span>Referrer</span>
                                <svg v-if="sortColumn === 'referrer_name'" 
                                     class="w-3 h-3 text-blue-600 -mt-0.5"
                                     fill="none" 
                                     stroke="currentColor" 
                                     viewBox="0 0 24 24"
                                >
                                    <path v-if="sortDirection === 'asc'"
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M5 15l7-7 7 7"
                                    />
                                    <path v-else
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                                <span v-else class="w-3"></span>
                            </div>
                        </th>
                        <th 
                            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none whitespace-nowrap"
                            @click="sortBy('referrer_email')"
                        >
                            <div class="flex items-center space-x-1">
                                <span>Referrer Email</span>
                                <svg v-if="sortColumn === 'referrer_email'" 
                                     class="w-3 h-3 text-blue-600 -mt-0.5"
                                     fill="none" 
                                     stroke="currentColor" 
                                     viewBox="0 0 24 24"
                                >
                                    <path v-if="sortDirection === 'asc'"
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M5 15l7-7 7 7"
                                    />
                                    <path v-else
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                                <span v-else class="w-3"></span>
                            </div>
                        </th>
                        <th 
                            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none whitespace-nowrap"
                            @click="sortBy('referred_name')"
                        >
                            <div class="flex items-center space-x-1">
                                <span>New User</span>
                                <svg v-if="sortColumn === 'referred_name'" 
                                     class="w-3 h-3 text-blue-600 -mt-0.5"
                                     fill="none" 
                                     stroke="currentColor" 
                                     viewBox="0 0 24 24"
                                >
                                    <path v-if="sortDirection === 'asc'"
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M5 15l7-7 7 7"
                                    />
                                    <path v-else
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                                <span v-else class="w-3"></span>
                            </div>
                        </th>
                        <th 
                            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none whitespace-nowrap"
                            @click="sortBy('referred_email')"
                        >
                            <div class="flex items-center space-x-1">
                                <span>New User Email</span>
                                <svg v-if="sortColumn === 'referred_email'" 
                                     class="w-3 h-3 text-blue-600 -mt-0.5"
                                     fill="none" 
                                     stroke="currentColor" 
                                     viewBox="0 0 24 24"
                                >
                                    <path v-if="sortDirection === 'asc'"
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M5 15l7-7 7 7"
                                    />
                                    <path v-else
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                                <span v-else class="w-3"></span>
                            </div>
                        </th>
                        <th 
                            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none whitespace-nowrap"
                            @click="sortBy('plan_type')"
                        >
                            <div class="flex items-center space-x-1">
                                <span>Plan Type</span>
                                <svg v-if="sortColumn === 'plan_type'" 
                                     class="w-3 h-3 text-blue-600 -mt-0.5"
                                     fill="none" 
                                     stroke="currentColor" 
                                     viewBox="0 0 24 24"
                                >
                                    <path v-if="sortDirection === 'asc'"
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M5 15l7-7 7 7"
                                    />
                                    <path v-else
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                                <span v-else class="w-3"></span>
                            </div>
                        </th>
                        <th 
                            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none whitespace-nowrap"
                            @click="sortBy('plan_price')"
                        >
                            <div class="flex items-center space-x-1">
                                <span>Plan Price</span>
                                <svg v-if="sortColumn === 'plan_price'" 
                                     class="w-3 h-3 text-blue-600 -mt-0.5"
                                     fill="none" 
                                     stroke="currentColor" 
                                     viewBox="0 0 24 24"
                                >
                                    <path v-if="sortDirection === 'asc'"
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M5 15l7-7 7 7"
                                    />
                                    <path v-else
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                                <span v-else class="w-3"></span>
                            </div>
                        </th>
                        <th 
                            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none whitespace-nowrap"
                            @click="sortBy('created_at')"
                        >
                            <div class="flex items-center space-x-1">
                                <span>Signup Date</span>
                                <svg v-if="sortColumn === 'created_at'" 
                                     class="w-3 h-3 text-blue-600 -mt-0.5"
                                     fill="none" 
                                     stroke="currentColor" 
                                     viewBox="0 0 24 24"
                                >
                                    <path v-if="sortDirection === 'asc'"
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M5 15l7-7 7 7"
                                    />
                                    <path v-else
                                          stroke-linecap="round" 
                                          stroke-linejoin="round" 
                                          stroke-width="2" 
                                          d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                                <span v-else class="w-3"></span>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="referral in sortedReferrals" :key="referral.id">
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ referral.referrer_name }}</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ referral.referrer_email }}</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ referral.referred_name }}</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ referral.referred_email }}</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ referral.plan_type }}</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ referral.plan_price }}</td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ formatDate(referral.created_at) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <p v-else class="text-gray-600 p-6">No referrals found.</p>
    </div>
</template>

<script>
import { orderBy } from 'lodash';

export default {
    name: 'ReferralsTable',

    props: {
        referrals: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            sortColumn: 'created_at',
            sortDirection: 'desc',
        };
    },

    computed: {
        sortedReferrals() {
            return orderBy(
                this.referrals,
                [this.sortColumn],
                [this.sortDirection]
            );
        },
    },

    methods: {
        sortBy(column) {
            if (this.sortColumn === column) {
                // Toggle direction if clicking the same column
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                // Set new column and default to ascending
                this.sortColumn = column;
                this.sortDirection = 'asc';
            }
            // Emit sort change event
            this.$emit('sort-changed', {
                column: this.sortColumn,
                direction: this.sortDirection,
            });
            // Also emit on the root Vue instance for cross-component communication
            if (this.$root && this.$root.$emit) {
                this.$root.$emit('referrals-sort-changed', {
                    column: this.sortColumn,
                    direction: this.sortDirection,
                });
            }
        },
        formatDate(dateString) {
            if (!dateString) {
                return '';
            }
            try {
                const date = new Date(dateString);
                if (isNaN(date.getTime())) {
                    return '';
                }
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            } catch (e) {
                return '';
            }
        },
    },
};
</script>

